<template>
  <tr v-if="$vuetify.breakpoint.smAndUp">
    <td :style="`width: ${columnWidths[0]}`" />
    <td :style="`width: ${columnWidths[1]}`">
      <v-row class="ma-0">
        <v-col
          cols="12"
          sm="6"
          lg="2"
        >
          {{ employee.name }}
        </v-col>
        <v-col
          cols="12"
          sm="6"
          lg="4"
        >
          {{ $t('course_report.date_of_attendance') }}： {{ employee.display }}
        </v-col>
        <v-col
          cols="12"
          sm="6"
          lg="3"
        >
          {{ $t('common.pre_course') }}：
          <span v-if="employee.pre">
            {{ $t('course_report.submitted') }}
          </span>
          <span v-else-if="!seminar.report">
            -
          </span>
          <span
            v-else
            style="color: red"
          >
            {{ $t('course_report.not_submitted') }}
          </span>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          lg="3"
        >
          {{ $t('common.post_course') }}：
          <span v-if="employee.post">
            {{ $t('course_report.submitted') }}
          </span>
          <span v-else-if="!seminar.report">
            -
          </span>
          <span
            v-else
            style="color: red"
          >
            {{ $t('course_report.not_submitted') }}
          </span>
        </v-col>
      </v-row>
    </td>
    <td :style="`width: ${columnWidths[2]}`">
      <v-btn
        v-if="justSent"
        icon
      >
        <v-icon color="green darken-1">
          mdi-check
        </v-icon>
      </v-btn>
      <v-btn
        v-else-if="seminar.mail"
        :disabled="disabled"
        :loading="loading"
        color="primary"
        icon
        @click="isOpened = true"
      >
        <v-icon>mdi-email-outline</v-icon>

        <v-dialog
          v-model="isOpened"
          activator="parent"
          width="500"
        >
          <v-card>
            <v-card-title>{{ $t('common.confirmation') }}</v-card-title>
            <v-card-text>{{ $t('course_report.send_confirmation') }}</v-card-text>
            <v-checkbox
              readonly
              hide-details
              dense
              :ripple="false"
              color="green darken-2"
              class="mx-5"
              input-value="true"
              :label="employee.name"
            />
            <v-card-actions class="mb-2 mt-4">
              <v-spacer />
              <v-btn
                density="default"
                variant="text"
                elevation="0"
                @click="isOpened = false"
              >
                {{ $t('common.cancel') }}
              </v-btn>
              <v-btn
                color="primary"
                @click="confirm()"
              >
                {{ $t('course_report.send_mail') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-btn>
    </td>
    <td :style="`width: ${columnWidths[3]}`" />
  </tr>
  <tr v-else>
    <td :style="`width: ${columnWidths[0]}`">
      {{ employee.name }}
    </td>
    <td>
      <v-btn
        v-if="justSent"
        icon
      >
        <v-icon color="green darken-1">
          mdi-check
        </v-icon>
      </v-btn>
      <v-btn
        v-else-if="seminar.mail"
        :loading="loading"
        :disabled="disabled"
        color="primary"
        icon
        @click="isOpened = true"
      >
        <v-icon>mdi-email-outline</v-icon>

        <v-dialog
          v-model="isOpened"
          activator="parent"
          width="500"
        >
          <v-card>
            <v-card-title>{{ $t('common.confirmation') }}</v-card-title>
            <v-card-text>{{ $t('course_report.send_confirmation') }}</v-card-text>
            <v-checkbox
              class="mx-5"
              color="green"
              input-value="true"
              :label="employee.name"
              readonly
            />
            <v-card-actions class="mb-2 mt-4">
              <v-spacer />
              <v-btn
                density="default"
                variant="text"
                elevation="0"
                @click="isOpened = false"
              >
                {{ $t('common.cancel') }}
              </v-btn>
              <v-btn
                color="primary"
                @click="confirm()"
              >
                {{ $t('course_report.send_mail') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-btn>
    </td>
  </tr>
</template>

<script>
import QUATSError from '../../../plugins/error'

export default {
  props: {
    disabled: {
      required: true,
      type: Boolean
    },
    employee: {
      required: true,
      type: Object
    },
    seminar: {
      required: true,
      type: Object
    },
    columnWidths: {
      required: true,
      type: Array
    }
  },

  data() {
    return {
      justSent: false,
      isOpened: false,
      loading: false
    }
  },

  methods: {
    sendReminderEmail(employee) {
      this.loading = true
      window.axios.post('/api/employee-course-report/seminar/send/email', {
        employee_list: [{
          name: employee.name,
          email: employee.email,
          start_date: employee.start_date,
          end_date: employee.end_date,
          is_post: employee.post,
          is_pre: employee.pre,
          seminar_name: employee.seminar_name
        }]
      })
        .then(() => {
          this.$store.commit('snackbar/successSnackbar', [this.$t('course_report.send_success_message')])
        })
        .catch((err) => {
          this.$store.commit('snackbar/errorSnackbar', [new QUATSError(this.$i18n, err).message])
        })
        .finally(() => {
          this.loading = false
          this.justSent = true
          setTimeout(() => {
            this.justSent = false
          }, 1000)
        })
    },
    confirm() {
      this.isOpened = false
      this.sendReminderEmail(this.employee)
    }
  }
}
</script>

<style scoped>

</style>
